<template>
  <!-- <div class="check-exam-status" v-loading="loading"> -->
  <div class="check-exam-status">
    <div class="exam-header">
      <el-row type="flex" justify="space-between">
        <el-col :span="8" class="exam-title">
          <el-tooltip effect="light" :content="trainingInfo.trainingName" placement="right">
            <h3>{{ trainingInfo.trainingName }}</h3>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <div class="goback" v-if="!isDingding">
            <i class="iconfont icon-guanbi2" title="关闭" @click="closePage"></i>
            <span class="closeitem" @click="closePage">关闭</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="exam-main">
      <div class="result-wrapper">
        <div class="status-info">
          <div class="exam-user">
            <div class="exam-user-photo">
              <el-avatar
                v-if="trainingInfo.userId"
                :size="100"
                :src="'/oua2/getUserPhoto?type=relativePath&userId=' + trainingInfo.userId"
                @error="errorHandler"
              >
              </el-avatar>
            </div>
            <div class="exam-user-name">
              <span>{{ trainingInfo.userName }}</span>
            </div>
          </div>
          <el-tooltip class="item" effect="light" :content="trainingInfo.trainingName" placement="top">
            <div class="exam-title">
              <p>{{ trainingInfo.trainingName }}</p>
            </div>
          </el-tooltip>
          <!-- <div class="exam-dividing-line"></div> -->
          <!-- <div class="content">
            <div class="exam-scors-wrapperpass">
              <div v-if="trainingInfo.isPass === '0' || trainingInfo.isPass === '1'">
                练习成绩<span
                  class="exam-scors"
                  :class="{
                    'exam-scors-fail': trainingInfo.isPass === '0',
                    'exam-scors-pass': trainingInfo.isPass === '1',
                  }"
                >
                  {{ trainingInfo.showText }}</span
                >
              </div>
              <div v-else-if="trainingInfo.isPass === '不公布'">
                <span class="exam-scors"> {{ trainingInfo.showText }}</span>
              </div>
              <div v-else>
                <span>{{ "暂无成绩" }}</span>
              </div>
            </div>
          </div> -->

          <div class="table-content">
            <el-table max-height="350" ref="singleTable" :data="trainingInfo.presentRecordDtoList" highlight-current-row style="width: 100%">
              <el-table-column label="次数" width="80" align="center">
                <template slot-scope="scope"> 第{{ scope.row.times }}次 </template>
              </el-table-column>
              <el-table-column label="状态" width="90" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.status }}</span>
                </template>
              </el-table-column>
              <el-table-column property="rightRate" label="正确率" width="90" :show-overflow-tooltip="true" align="center"> </el-table-column>
              <el-table-column property="useTime" label="用时" width="180" :show-overflow-tooltip="true" align="center"> </el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="continueExam(scope.$index, scope.row)"
                    v-if="scope.row.status === '进行中' && isCurrent === true"
                    type="text"
                    size="small"
                  >
                    继续练习
                  </el-button>
                  <el-button v-else @click.native.prevent="checkDetails(scope.$index, scope.row)" type="text" size="small"> 查看详情 </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="exam-button-bar">
          <div @click="tryAgain" class="exam-button-item" v-if="trainingInfo.status !== '历史' && isCurrent === false">
            <span>开始练习</span>
          </div>

          <div @click="continueExam" class="exam-button-item" v-else-if="trainingInfo.status !== '历史' && isCurrent === true">继续练习</div>
          <div @click="closePage" class="exam-button-item" v-else-if="!isDingding">关闭</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfPracticeResult",
  data() {
    return {
      loading: false,
      trainingInfo: {},
      isDingding: dsf.cookies.get("isDd"), // 网络学院内处理掉按钮
    };
  },
  computed: {
    //练习状态    当前练习中的练习转态=>进行中
    isCurrent() {
      if (this.trainingInfo.presentRecordDtoList && this.trainingInfo.status !== "历史") {
        //继续练习
        var current = this.trainingInfo.presentRecordDtoList.some((exam) => exam.status == "进行中");
      }
      return current;
    },
  },
  created() {},
  mounted() {
    //发送请求
    this.getTrainingHistory();
  },

  methods: {
    errorHandler() {
      return true;
    },

    //查看历史记录接口
    getTrainingHistory() {
      this.loading = true;
      this.$http
        .get(
          "/training/getTrainingHistory",
          {
            trainingId: this.$route.query.trainingId,
          },
          $$webRoot.exam
        )
        .done((res) => {
          if (res.success) {
            this.trainingInfo = {
              ...res.data[0],
            };
            this.loading = false;
          } else {
            this.loading = true;
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
          this.loading = true;
        });
    },

    //查看练习
    checkDetails(index, row) {
      this.$router.push("/pc/exam/exam-practice?id=" + this.$route.query.trainingId + "&recordId=" + row.recordId + "&type=3")
      // 钉钉里跳转问题修改
      // let url = location.pathname + "#/pc/exam/exam-practice?id=" + this.$route.query.trainingId + "&recordId=" + row.recordId + "&type=3";
      // location.replace(url);
    },

    //关闭
    closePage() {
      window.close();
      window.history.go(-1);
    },

    //开始练习
    tryAgain() {
      let url = location.pathname + "#/pc/exam/exam-practice?id=" + this.$route.query.trainingId;
      location.replace(url);
    },

    //继续练习
    continueExam(index, row) {
      var exam = this.trainingInfo.presentRecordDtoList.filter((exam) => {
        return exam.status == "进行中";
      });
      if (row) {
        this.$router.push("/pc/exam/exam-practice?id=" + this.$route.query.trainingId + "&recordId=" + row.recordId || "");
      } else {
        if (exam && exam[0]) {
          this.$router.push("/pc/exam/exam-practice?id=" + this.$route.query.trainingId + "&recordId=" + exam[0].recordId || "");
        }
      }
    },
  },
};
</script>
